<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  
  
          <div class="row margin-top-10">
            <div class="col-md-6 padding-right-5px padding-left-5px ">
              <div class="row my-profile-form margin-bottom-3px" hidden>
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">



                    <div class="col-md-12 ">

                      <CodeTypeValue CodeType="QKOPT">
                      </CodeTypeValue>

                    </div>

                  </div>


                </div>
              </div>
            </div>
            <div class="col-md-6 padding-right-5px padding-left-5px  ">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)" hidden></search-list>

              <div class="ng-autocomplete width-150px margin-top--3px margin-bottom-8px border-left-5px-dodgerblue border-bottom-2px-dodgerblue">
                <ng-autocomplete [data]="PatientsData"
                                 [searchKeyword]="keyword"
                                 placeholder="Patient Code"
                                 (selected)='selectEvent($event)'
                                 (inputChanged)='onChangeSearch($event)'
                                 (inputFocused)='onFocused($event)'
                                 [itemTemplate]="itemTemplate"
                                 [notFoundTemplate]="notFoundTemplate"
                                 >
                </ng-autocomplete>
                <ng-template #itemTemplate let-item>
                 
                  <a [innerHTML]="item.FormattedCode"></a>
                </ng-template>
                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
              </div>
          </div>
        </div>
      
    
 


